<script>
    import { Spinner } from 'sveltestrap'
    import Form from './form.svelte'

    import { navigate } from 'svelte-routing'

    import { Tasks } from '../../middleware/database/tasks'
    import date from 'date-and-time'
    import { currentUser } from '../../stores/current_user'

    export let id = null
    export let location = null

    let loading = true
    let task = {}
    let copyImages = {}

    $: if (loading) {

        Tasks.findOne(id)
            .then(doc => {
                doc.subtasks.forEach(s => {
                    copyImages[s.id] = (s.photos) ? [...s.photos] : []
                })
                doc.subtasks = doc.subtasks.map(s => s.id)
                doc.expire = (doc.expire) ? date.format(doc.expire, 'YYYY-MM-DD') : ''
                doc.projectId = (doc.projectId) ? doc.projectId : '--NO-PROJECT--'
                doc.agentId = (doc.agentId) ? doc.agentId : '--NO-AGENT--'
                task = doc
                loading = false
            })
            .catch(err => {
                console.log(`Error occured while fetching Task from Firestore. ${err}`)
            })

    }

    function updateTask(event) {

        let delta = event.detail

        // back to Date object
        if (delta.expire)
            delta.expire = date.parse(delta.expire, 'YYYY-MM-DD')

        // attach photos again
        if (delta.subtasks) {
            delta.subtasks.forEach(s => {
                if (copyImages.hasOwnProperty(s.id))
                    s.photos = copyImages[s.id]
            })
        }
        
        if (delta.agentId)
            delta.agentId = (delta.agentId === '--NO-AGENT--') ? null : delta.agentId
            
        if (delta.projectId)
            delta.projectId = (delta.projectId === '--NO-PROJECT--') ? null : delta.projectId

        delta.updatedAt = new Date()
        delta.updatedBy = $currentUser.id

        Tasks.update(id, delta).then(() => {
            copyImages = {}
            navigate('/tasks')
        }).catch(err => {
            console.log(err)
        })

    }

</script>

{#if loading}
    <Spinner size="lg" color="dark" type="grow" />
{:else}
    <Form pageTitle="Edit task" {task} on:submit={updateTask}/>
{/if}